import React, { useState, useEffect } from 'react'
import TextArea from 'components/textarea/TextArea'
import Label from 'components/Label/Label'
import { useParams, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import {
  notInterested,
  getStudentData,
  updateCurrentState,
  getCollege,
} from 'modules/Onboarding/actions'
import {
  Content,
  RadioLocal,
  RadioLocalGroup,
  LocalSpace,
  FlexWrap,
  LogoSmallText,
  LogoBigText,
  Logo,
  Wrapper,
} from 'modules/Onboarding/Components/NotInterested/NotIntrested/style'

import {
  Container,
  Heading,
  Para,
  Anchor,
} from 'modules/Onboarding/Components/ActivateAccount/ActivatePage/style'

import ErrorMessage from 'utils/ErrorMessage'

const NotIntrested = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const params = useParams()

  const [value, setValue] = useState('goingForHigherStudies')
  const [description, setDescription] = useState('')
  const studentId = params.studentId
  const studentData = useSelector(state => state?.studentData?.studentDetails)

  useEffect(() => {
    dispatch(getStudentData(studentId))
  }, [studentId])

  useEffect(() => {
    if (studentData?.instituteCampusId) {
      dispatch(getCollege(studentData?.instituteCampusId))
    }
  }, [studentData])

  useEffect(() => {
    if (studentData?.currentState === -1) {
      navigate(`/not-interested/final/${studentId}`)
    }
  }, [studentData])

  const onChangeOfNotIntrested = async () => {
    let payload = {
      reason: value,
      description: description,
    }
    let response = await dispatch(notInterested(studentId, payload))

    if (response === true) {
      dispatch(updateCurrentState(studentId, -1))
      navigate(`/not-interested/final/${studentId}`)
    } else {
      ErrorMessage(response?.response?.data?.message)
    }
  }

  return (
    <Container alignCenter column>
      <Wrapper>
        <Content spaceBetween flexStart column>
          <Heading>Hello {studentData?.admin?.first_name},</Heading>
          <Para>
            Would you take a moment and tell us the reason for not interested in
            the college placement service.
          </Para>
          <RadioLocalGroup
            onChange={e => {
              setValue(e.target.value);
              setDescription('');
            }}
            value={value}
          >
            <LocalSpace direction="vertical">
              <RadioLocal value={'goingForHigherStudies'}>
                Going for 'Higher Studies’
              </RadioLocal>
              <RadioLocal value={'startingMyOwnBusiness'}>
                Starting my own business
              </RadioLocal>
              <RadioLocal value={'joiningFamilyBusiness'}>
                Joining family business
              </RadioLocal>
              <RadioLocal value={'other'}>
                Other (Mention the reason below)
              </RadioLocal>
            </LocalSpace>
          </RadioLocalGroup>
          {value === 'other' ? (
            <FlexWrap flexStart column>
              <Label color="#4D566E">Mention the reason *</Label>
              <TextArea
                placeholder="Eg: Already got an offer outside college"
                onChange={e => setDescription(e.target.value)}
              />
            </FlexWrap>
          ) : null}

          <Anchor onClick={() => onChangeOfNotIntrested()}>Submit</Anchor>
        </Content>
        <Logo center alignCenter column>
          <LogoSmallText>Powered by</LogoSmallText>
          <LogoBigText>PluginLive</LogoBigText>
        </Logo>
      </Wrapper>
    </Container>
  )
}

export default NotIntrested
